import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILink from 'UIComponents/link/UILink';
import { EERIE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const KNOWLEDGE_BASE_URL = 'https://knowledge.hubspot.com/chatflows/chat-with-logged-in-visitors';
const IdentifyContactBadge = () => {
  const learnMore = /*#__PURE__*/_jsx(UILink, {
    use: "on-bright",
    href: KNOWLEDGE_BASE_URL,
    external: true,
    children: I18n.text('conversations-inbox-ui.crm-integration.IdentifyContactTip.learnMore')
  });
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-ui.crm-integration.IdentifyContactTip.verified",
      options: {
        learnMore
      }
    }),
    "data-test-id": "identify-contact-badge-tooltip",
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "twoFAFill",
      size: "small",
      color: EERIE,
      "data-test-id": "identify-contact-badge-icon"
    })
  });
};
IdentifyContactBadge.displayName = 'IdentifyContactBadge';
IdentifyContactBadge.propTypes = {};
export default IdentifyContactBadge;